module.exports = __webpack_public_path__ + "img/recolumn_example10.529b9a40.png";